"use client";
import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Card, Col, FormGroup, Row, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  PaginationComponent,
  RSelect,
} from "../../../components/Component";
import DropSelectButton from "../../../components/DropSelectButton/DropSelectButton";
import { ReportTable } from "../../../components/table/SpecialTable";
import { authHeader } from "../../../header";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { CSVDownload } from "react-csv";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import moment from "moment";
import "jspdf-autotable";

export const ReportManagementScreen = () => {
  const reportTypeEnum = {
    TRANSACTION: "TRANSACTION_REPORT",
    INVESTMENT: "INVESTMENT_REPORT",
    REFERRALS: "REFERRALS_REPORT",
    INTEREST_EXPENSE: "INTEREST_EXPENSE_REPORT",
    CUSTOMER_WALLET_TRANSACTION: "CUSTOMER_WALLET_TRANSACTION_REPORT",
    CUSTOMER_REGISTRATION: "CUSTOMER_REGISTRATION_REPORT",
    CUSTOMER_SOURCE: "CUSTOMER_SOURCE_REPORT",
    ADHOC_INVESTMENT: "ADHOC_INVESTMENT_REPORT",
    CBN_MOM_INVESTMENT: "CBN_MOM_INVESTMENT_REPORT",
    WALLET_PORTFOLIO: "WALLET_PORFOLIO_REPORT",
    ACTIVE_CUSTOMERS: "ACTIVE_CUSTOMER_REPORT",
    TAT_REPORT: "TAT_REPORT",
  };

  const initialFieldsDTO = {
    transactionType: "all",
    customerId: "",
    startDate: "",
    endDate: "",
    investmentType: "",
    referralCode: "",
    filterBy: "",
    source: "",
    customerType: "all",
    accountType: "all",
    productType: "all",
    activeProductType: "RWIN,RTN,REAP",
  };

  const [isLoading, setIsLoading] = useState(false);
  const [reportType, setReportType] = useState(reportTypeEnum.TRANSACTION);
  const [selectedDownloadType, setSelectedDownloadType] = useState("PDF");
  const [generatedReport, setGeneratedReport] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [downloadClicked, setDownloadClicked] = useState(false);
  const [itemPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [products, setProducts] = useState([]);
  const [fields, setFields] = useState(initialFieldsDTO);

  const tatTableHead = [
    "Customer Id",
    "Transaction Id",
    "Customer name",
    "Withdrawal amount",
    "Process stage",
    "Current step",
    "Created at",
    "Last updated at",
    "End Action",
    "Staff name",
  ];

  const transactionTableHead = [
    "Transaction Date",
    "Transaction ID",
    "Customer ID",
    "Customer Name",
    "Product",
    "Transaction Amount",
    "Transaction Type",
    "Transaction Description",
    "DR Account",
    "CR Account",
  ];

  const investmentTableHead = [
    "Customer ID",
    "Customer Name",
    "Customer Email",
    "Customer Phone",
    "Product Type",
    "Investment Amount",
    "Interest Rate",
    "Tenor Days",
    "Interest Option",
    "Creation Date",
    "Maturity Date",
    "Interest Accrued",
    "Plan Status",
    "Days Elapsed",
  ];

  const adHocInvestmentTableHead = [
    "Customer ID",
    "Customer / Company Name",
    "Account Type",
    "Product Name",
    "Interest Rate",
    "Business Unit",
    "Tenor",
    "Interest Payment Option",
    "Investment Date",
    "Rollover Status",
    "Account Officer",
  ];

  const cbnMomTableHead = [
    "Customer ID",
    "Customer / Company Name",
    "Face Amount",
    "Borrowed Amount",
    "Effective Date",
    "Interest Rate",
    "Tenor",
    "Maturity Date",
    "Interest Amount",
    "Repayment Amount",
    "No of Days",
  ];

  const customerRegistrationTableHead = [
    "Registration Date",
    "Customer ID",
    "Status",
    "First Name / Last Name / Company Name",
    "Customer Type",
    "Email",
    "Phone Number",
    "State",
    "Gender",
    "Reserved Account Number",
    "Investment Status",
    "Referral Code",
  ];

  const walletPortfolioTableHead = ["Customer ID", "Customer Name", "Customer Type", "Wallet Balance"];

  const activeCustomerTableHead = [
    "Account Officer Name",
    "Customer ID",
    "Customer Name",
    "BVN",
    "Date of Birth",
    "Email Address",
    "Face Value",
    "Interest Rate",
    "Gender",
    "Tenor Days",
    "Phone Number",
    "Maturity Date",
    "Outstanding Balance",
    "Effective Date",
    "Referral Code",
  ];

  const referralsTableHead = [
    "Registration Date",
    "Customer ID",
    "Customer Name / Company Name",
    "Customer Type",
    "Source",
    "Referred By",
    "Investment Status",
    "Activation Bonus Redeemed",
  ];

  const interestExpenseTableHead = [
    "Date",
    "Customer ID",
    "Plan Name",
    "Investment Balance",
    "Interest Earned",
    "WHT",
    "Interest Payout Amount",
    "Interest Rate",
    "Investment Creation Date",
    "Investment Maturity Date",
    "Interest Option",
  ];

  const customerWalletTransactionTableHead = [
    "Date of Transaction",
    "Tran ID",
    "Description",
    "Tran Type",
    "Tran Amount",
    "Balance",
  ];

  const customerSourceTableHead = [
    "Registration Date",
    "Customer ID",
    "Customer Name",
    "Customer Type",
    "Channel",
    "Source",
    "Referred By",
    "Others",
    "Investment Status",
  ];

  const expandTATRowsForExport = (data) => {
    const expandedData = [];
    console.log(data);

    data.forEach((item) => {
      const transactionId = item.transactionId ?? "N/A";
      const customerName = item.customerName ?? "N/A";
      const withdrawalAmount = item.withdrawalAmount ?? "N/A";
      const finalStatus = item.endAction ?? "N/A";
      const customerId = item?.customerId ?? "N/A";

      const auditTrail = item.withdrawalRequestAuditTrail || [];

      if (auditTrail.length > 0) {
        const sortedStages = [...auditTrail].sort((a, b) => {
          const parseDate = (dateStr) => {
            if (!dateStr) return new Date(0);

            const [datePart, timePart, ampm] = dateStr.split(" ");
            const [day, month, year] = datePart.split("-").map(Number);
            let [hours, minutes] = timePart.split(":").map(Number);

            if (ampm === "PM" && hours !== 12) hours += 12;
            if (ampm === "AM" && hours === 12) hours = 0;

            return new Date(year, month - 1, day, hours, minutes);
          };

          return parseDate(a.createdAt) - parseDate(b.createdAt);
        });

        sortedStages.forEach((stage, index) => {
          const isLastStage = index === sortedStages.length - 1;

          expandedData.push({
            customerId,
            transactionId,
            customerName,
            withdrawalAmount,
            processStage: stage.departmentThatTreated ?? "N/A",
            currentStep: stage.stageName ?? "N/A",
            createdAt: stage.createdAt ?? "N/A",
            lastUpdatedAt: stage.updatedAt ?? stage.createdAt ?? "N/A",
            endAction: stage?.endAction ?? "N/A",
            staffName: stage.staffName ?? "N/A",
          });
        });
      } else {
        expandedData.push({
          customerId,
          transactionId,
          customerName,
          withdrawalAmount,
          processStage: "N/A",
          currentStep: "N/A",
          createdAt: item.createdAt ?? "N/A",
          lastUpdatedAt: item.lastUpdatedAt ?? "N/A",
          endAction: finalStatus,
          staffName: "N/A",
        });
      }
    });

    return expandedData;
  };

  const transactionTableBody = generatedReport?.map((item) => {
    return [
      item?.transactionDate ?? "N/A",
      item?.transactionId ?? "N/A",
      item?.customerId ?? "N/A",
      item?.customerName ?? "N/A",
      item?.product ?? "N/A",
      item?.transactionAmount ?? "N/A",
      item?.transactionType ?? "N/A",
      item?.transactionDescription ?? "N/A",
      item?.drAccount ?? "N/A",
      item?.crAccount ?? "N/A",
    ];
  });

  const tatTableBody = () => {
    const expandedData = expandTATRowsForExport(generatedReport);

    return expandedData.map((item) => [
      item.customerId,
      item.transactionId,
      item.customerName,
      item.withdrawalAmount,
      item.processStage,
      item.currentStep,
      item.createdAt,
      item.lastUpdatedAt,
      item.endAction,
      item.staffName,
    ]);
  };

  const formatTatReportForExport = (data) => {
    return expandTATRowsForExport(data);
  };

  const activeCustomerTableBody = generatedReport?.map((item) => {
    return [
      item?.accountOfficerName ?? "N/A",
      item?.customerId ?? "N/A",
      item?.customerName ?? "N/A",
      item?.bvn ?? "N/A",
      item?.dateOfBirth ?? "N/A",
      item?.emailAddress ?? "N/A",
      item?.faceValue ?? "N/A",
      item?.interestRate ?? "N/A",
      item?.gender ?? "N/A",
      item?.tenorDays ?? "N/A",
      item?.phoneNumber ?? "N/A",
      item?.maturityDate ?? "N/A",
      item?.outstandingBalance ?? "N/A",
      item?.effectiveDate ?? "N/A",
      item?.referralCode ?? "N/A",
    ];
  });

  const investmentTableBody = generatedReport?.map((item) => {
    return [
      item?.customerId ?? "N/A",
      item?.customerName ?? "N/A",
      item?.customerEmail ?? "N/A",
      item?.customerPhone ?? "N/A",
      item?.productType ?? "N/A",
      item?.investmentAmount ?? "N/A",
      item?.interestRate ?? "N/A",
      item?.tenorDays ?? "N/A",
      item?.interestOption ?? "N/A",
      item?.creationDate ?? "N/A",
      item?.maturityDate ?? "N/A",
      item?.interestAccrued?.toFixed(2) ?? "N/A",
      item?.planStatus ?? "N/A",
      item?.daysElapsed ?? "N/A",
    ];
  });

  const adHocInvestmentTableBody = generatedReport?.map((item) => {
    return [
      item?.customerId ?? "N/A",
      item?.customerOrCompanyName ?? "N/A",
      item?.accountType ?? "N/A",
      item?.productName ?? "N/A",
      item?.interestRate ?? "N/A",
      item?.businessUnit ?? "N/A",
      item?.tenor ?? "N/A",
      item?.interestPaymentOption ?? "N/A",
      item?.investmentDate ?? "N/A",
      item?.rolloverStatus ?? "N/A",
      item?.accountOfficer ?? "N/A",
    ];
  });

  const referralsTableBody = generatedReport?.map((item) => {
    return [
      item?.registrationDate ?? "N/A",
      item?.customerId ?? "N/A",
      item?.customerName ?? item?.companyName ?? "N/A",
      item?.customerType ?? "N/A",
      item?.source ?? "N/A",
      item?.referredBy ?? "N/A",
      item?.investmentStatus ?? "N/A",
      item?.activationBonusRedeemed === true ? "YES" : ("NO" ?? "N/A"),
    ];
  });

  const interestExpenseTableBody = generatedReport?.map((item) => {
    return [
      item?.date ?? "N/A",
      item?.customerId ?? "N/A",
      item?.planName ?? "N/A",
      item?.investmentBalance ?? "N/A",
      item?.interestEarned ?? "N/A",
      item?.wht?.toFixed(2) ?? "N/A",
      item?.interestPayoutAmount?.toFixed(2) ?? "N/A",
      item?.interestRate ?? "N/A",
      item?.investmentCreationDate ?? "N/A",
      item?.investmentMaturityDate ?? "N/A",
      item?.interestOption ?? "N/A",
    ];
  });

  const customerWalletTransactionTableBody = generatedReport?.map((item) => {
    return [
      item?.dateOfTransaction ?? "N/A",
      item?.tranId ?? "N/A",
      item?.description ?? "N/A",
      item?.tranType ?? "N/A",
      item?.tranAmount ?? "N/A",
      item?.balance ?? "N/A",
    ];
  });

  const customerRegistrationTableBody = generatedReport?.map((item) => {
    return [
      item?.registrationDate ?? "N/A",
      item?.customerId ?? "N/A",
      item?.status ?? "N/A",
      item?.firstName || item?.lastName
        ? `${item?.firstName ?? ""} ${item?.lastName ?? ""}`
        : (item?.companyName ?? "N/A"),
      item?.customerType ?? "N/A",
      item?.email ?? "N/A",
      item?.phoneNumber ?? "N/A",
      item?.state ?? "N/A",
      item?.gender ?? "N/A",
      item?.reservedAccountNumber ?? "N/A",
      item?.investmentStatus ?? "N/A",
      item?.referralCode ?? "N/A",
    ];
  });

  const customerSourceTableBody = generatedReport?.map((item) => {
    return [
      item?.registrationDate ?? "N/A",
      item?.customerId ?? "N/A",
      item?.customerName ?? item?.companyName ?? "N/A",
      item?.customerType ?? "N/A",
      item?.registrationChannel ?? "N/A",
      item?.source ?? "N/A",
      item?.referredBy ?? item?.others ?? "N/A",
      item?.others ?? "N/A",
      item?.investmentStatus ?? "N/A",
    ];
  });

  const cbnMomTableBody = generatedReport?.map((item) => {
    return [
      item?.customerId ?? "N/A",
      item?.customerName ?? item?.companyName ?? "N/A",
      item?.faceAmount ?? "N/A",
      item?.borrowedAmount ?? "N/A",
      item?.effectiveDate ?? "N/A",
      item?.interestRate ?? "N/A",
      item?.tenor ?? "N/A",
      item?.maturityDate ?? "N/A",
      item?.interestAmount ?? "N/A",
      item?.repaymentAmount ?? "N/A",
      item?.noOfDays ?? "N/A",
    ];
  });

  const walletPortfolioTableBody = generatedReport?.map((item) => {
    return [
      item?.customerId ?? "N/A",
      item?.customerName ?? "N/A",
      item?.customerType ?? "N/A",
      item?.walletBalance ?? "N/A",
    ];
  });

  const getAllProductType = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trproduct`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setProducts(resultData);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const savePdf = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: "A4",
    });

    doc.autoTable({
      margin: { top: 30, left: 20, right: 20 },
      styles: {
        fontSize: 7, // smaller text as requested
        cellPadding: 2, // tighter spacing
        valign: "middle",
        overflow: "linebreak",
      },
      headStyles: {
        fontSize: 8, // slightly larger for header contrast
        halign: "center", // header alignment only
        // No fillColor or textColor — using defaults now
      },
      bodyStyles: {
        halign: "center",
      },

      head: [
        reportType === reportTypeEnum.TRANSACTION
          ? transactionTableHead
          : reportType === reportTypeEnum.INVESTMENT
            ? investmentTableHead
            : reportType === reportTypeEnum.ADHOC_INVESTMENT
              ? adHocInvestmentTableHead
              : reportType === reportTypeEnum.CBN_MOM_INVESTMENT
                ? cbnMomTableHead
                : reportType === reportTypeEnum.CUSTOMER_REGISTRATION
                  ? customerRegistrationTableHead
                  : reportType === reportTypeEnum.WALLET_PORTFOLIO
                    ? walletPortfolioTableHead
                    : reportType === reportTypeEnum.ACTIVE_CUSTOMERS
                      ? activeCustomerTableHead
                      : reportType === reportTypeEnum.REFERRALS
                        ? referralsTableHead
                        : reportType === reportTypeEnum.CUSTOMER_WALLET_TRANSACTION
                          ? customerWalletTransactionTableHead
                          : reportType === reportTypeEnum.INTEREST_EXPENSE
                            ? interestExpenseTableHead
                            : reportType === reportTypeEnum.TAT_REPORT
                              ? tatTableHead
                              : customerSourceTableHead,
      ],

      body:
        reportType === reportTypeEnum.TRANSACTION
          ? transactionTableBody
          : reportType === reportTypeEnum.INVESTMENT
            ? investmentTableBody
            : reportType === reportTypeEnum.ACTIVE_CUSTOMERS
              ? activeCustomerTableBody
              : reportType === reportTypeEnum.ADHOC_INVESTMENT
                ? adHocInvestmentTableBody
                : reportType === reportTypeEnum.CBN_MOM_INVESTMENT
                  ? cbnMomTableBody
                  : reportType === reportTypeEnum.CUSTOMER_REGISTRATION
                    ? customerRegistrationTableBody
                    : reportType === reportTypeEnum.WALLET_PORTFOLIO
                      ? walletPortfolioTableBody
                      : reportType === reportTypeEnum.REFERRALS
                        ? referralsTableBody
                        : reportType === reportTypeEnum.CUSTOMER_WALLET_TRANSACTION
                          ? customerWalletTransactionTableBody
                          : reportType === reportTypeEnum.INTEREST_EXPENSE
                            ? interestExpenseTableBody
                            : reportType === reportTypeEnum.TAT_REPORT
                              ? tatTableBody()
                              : customerSourceTableBody,
    });

    doc.save(`${reportType}.pdf`);
  };

  const handleReportTypeChange = (val) => {
    setReportType(val);
    resetFilterFields();
  };

  const onInputChange = (e) => {
    setFields({ ...fields, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (e, name) => {
    setFields({ ...fields, [name]: e.value });
  };

  const formatDateToIso = (date) => {
    if (moment(date).format("DD MM YYYY") !== "Invalid date") {
      return moment(date).format("DD-MM-yyyy");
    } else {
      return "";
    }
  };

  const {
    customerId,
    endDate,
    startDate,
    transactionType,
    investmentType,
    referralCode,
    filterBy,
    source,
    customerType,
    accountType,
    productType,
    activeProductType,
  } = fields;

  const reportToBeGenerated =
    reportType === reportTypeEnum.TRANSACTION
      ? "transaction"
      : reportType === reportTypeEnum.INVESTMENT
        ? "investment"
        : reportType === reportTypeEnum.ACTIVE_CUSTOMERS
          ? "active-customers"
          : reportType === reportTypeEnum.REFERRALS
            ? "referral"
            : reportType === reportTypeEnum.CBN_MOM_INVESTMENT
              ? "cbn-mom-investment"
              : reportType === reportTypeEnum.CUSTOMER_REGISTRATION
                ? "customer-registration"
                : reportType === reportTypeEnum.CUSTOMER_SOURCE
                  ? "customer-source"
                  : reportType === reportTypeEnum.CUSTOMER_WALLET_TRANSACTION
                    ? "customer-wallet-transaction-statement"
                    : reportType === reportTypeEnum.INTEREST_EXPENSE
                      ? "interest-expense"
                      : reportType === reportTypeEnum.WALLET_PORTFOLIO
                        ? "wallet-portfolio"
                        : reportType === reportTypeEnum.ADHOC_INVESTMENT
                          ? "adhoc-investment"
                          : reportType === reportTypeEnum.TAT_REPORT
                            ? "request-centre-tat"
                            : "";

  const generateReport = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/reports/generate-${reportToBeGenerated}-report?pageNo=${
          currentPage - 1
        }&pageSize=${itemPerPage}&startDate=${formatDateToIso(startDate)}&endDate=${formatDateToIso(endDate)}${
          reportType === reportTypeEnum.TRANSACTION
            ? `&transactionType=${transactionType}&customerId=${customerId}`
            : reportType === reportTypeEnum.INVESTMENT
              ? `&productType=${productType}&customerId=${customerId}`
              : reportType === reportTypeEnum.ACTIVE_CUSTOMERS
                ? `&productType=${activeProductType}&customerId=${customerId}&customerType=${accountType}`
                : reportType === reportTypeEnum.REFERRALS
                  ? `&referralCode=${referralCode}&customerId=${customerId}&source=${source}`
                  : reportType === reportTypeEnum.CUSTOMER_WALLET_TRANSACTION
                    ? `&customerId=${customerId}`
                    : reportType === reportTypeEnum.ADHOC_INVESTMENT
                      ? `&customerType=${accountType}&productType=${productType}&customerId=${customerId}`
                      : ""
        }`,
        null,
        {
          headers: authHeader(),
        },
      );
      const formData = await response.data;
      setTotal(formData?.data?.totalElements ?? 0);
      setGeneratedReport(formData?.data?.content ?? formData?.data ?? []);
      setIsLoading(false);
      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoading(false);
      return { message };
    }
  };

  useEffect(() => {
    if (
      reportType === reportTypeEnum.INVESTMENT ||
      reportType === reportTypeEnum.ADHOC_INVESTMENT ||
      reportType === reportTypeEnum.ACTIVE_CUSTOMERS
    ) {
      getAllProductType();
    }
  }, [reportType, reportTypeEnum.ADHOC_INVESTMENT, reportTypeEnum.INVESTMENT, reportTypeEnum.ACTIVE_CUSTOMERS]);

  const [generatedCsvReport, setGeneratedCsvReport] = useState([]);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const csvRef = React.useRef();

  const handleGenerateDocs = async (downloadCallback) => {
    setIsGeneratingReport(true);
    setGeneratedCsvReport([]);
    try {
      const request = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/admin/reports/generate-${reportToBeGenerated}-report${
          reportType == reportTypeEnum.TAT_REPORT ? "-full" : "/full"
        }?startDate=${formatDateToIso(startDate)}&endDate=${formatDateToIso(endDate)}${
          reportType === reportTypeEnum.TRANSACTION
            ? `&transactionType=${transactionType}&customerId=${customerId}`
            : reportType === reportTypeEnum.INVESTMENT
              ? `&productType=${investmentType}&customerId=${customerId}&customerType=${accountType}`
              : reportType === reportTypeEnum.REFERRALS
                ? `&referralCode=${referralCode}&customerId=${customerId}&source=${source}`
                : reportType === reportTypeEnum.CUSTOMER_WALLET_TRANSACTION
                  ? `&customerId=${customerId}`
                  : reportType === reportTypeEnum.ADHOC_INVESTMENT
                    ? `productType=${productType}`
                    : reportType === reportTypeEnum.ACTIVE_CUSTOMERS
                      ? `&productType=${activeProductType}&admin-usage=ADMIN_TREASURY`
                      : ""
        }`,
        null,
        {
          headers: authHeader(),
        },
      );
      const response = request.data;
      const generatedReports =
        reportType === reportTypeEnum.TAT_REPORT
          ? formatTatReportForExport(response?.data?.content ?? response?.data ?? [])
          : (response?.data?.content ?? response?.data ?? []);
      setGeneratedCsvReport(generatedReports);
      setIsGeneratingReport(false);
      if (selectedDownloadType === "XLSX") {
        downloadCallback(generatedReports);
      } else if (selectedDownloadType === "CSV" && csvRef.current) {
        setTimeout(() => csvRef.current?.link.click(), 100);
      }
    } catch (err) {
      console.log(err);
      setIsGeneratingReport(false);
    }
  };

  useEffect(() => {
    generateReport();
  }, [
    reportType,
    transactionType,
    customerId,
    endDate,
    startDate,
    investmentType,
    referralCode,
    source,
    filterBy,
    currentPage,
    customerType,
    accountType,
    activeProductType,
    productType,
  ]);

  const handleSelectDownloadType = (val) => {
    setSelectedDownloadType(val);
  };

  const currentItems = generatedReport ?? [];
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const transactionTypeOptions = [
    { label: "All", value: "all" },
    { label: "Plan Top Up", value: "PLAN_TOP_UP" },
    { label: "Part Withdrawal", value: "PART_WITHDRAWAL" },
    { label: "Full Withdrawal", value: "FULL_WITHDRAWAL" },
    { label: "Transfer", value: "TRANSFER" },
    { label: "Plan Roll Over", value: "PLAN_ROLL_OVER" },
  ];

  const productTypeOptions = [
    { label: "All", value: "RWIN,RTN,REAP" },
    { label: "RTN", value: "RTN" },
    { label: "REAP", value: "REAP" },
    { label: "RWIN", value: "RWIN" },
  ];

  const productOptions =
    products?.map((prod) => ({
      label: prod?.productName,
      value: prod?.productName,
    })) ?? [];

  const investmentTypeOptions = [{ label: "ALL", value: "all" }, ...productOptions];

  const customerTypeOptions = [
    { label: "All", value: "all" },
    { label: "Customer ID", value: "customer_id" },
  ];

  const filterByOptions = [
    { label: "Source", value: "source" },
    { label: "Referral Code", value: "referral_code" },
  ];

  const sourceOptions = [
    { label: "All", value: "OTHER" },
    { label: "Staff", value: "ROSABON_SALES" },
    { label: "Customer", value: "ANOTHER_USER" },
  ];

  const accountTypeOptions = [
    { label: "All", value: "all" },
    { label: "INDIVIDUAL USER", value: "INDIVIDUAL_USER" },
    { label: "COMPANY", value: "COMPANY" },
  ];

  const { errors, register } = useForm();

  const downloadExcel = (data) => {
    const isTatReport = reportType === reportTypeEnum.TAT_REPORT;
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `${reportType.split("_")[0]}`);
    XLSX.writeFile(workbook, `${reportType.toLowerCase()}.xlsx`);
  };

  const handleDownload = (report) => {
    const isReferrals = reportType === reportTypeEnum.REFERRALS;
    const isCustomerSource = reportType === reportTypeEnum.CUSTOMER_SOURCE;
    const isTatReport = reportType === reportTypeEnum.TAT_REPORT;

    if (isTatReport) {
      if (selectedDownloadType === "XLSX") {
        downloadExcel(report);
      }
    } else if (isReferrals) {
      const generatedExcelSheet = report.map((item) => ({
        "Registration Date": item.registrationDate,
        "Customer Name / Company Name": `${item.customerName ?? "."} ${item.companyName ?? "."}`,
        "Customer ID": item.customerId,
        "Customer Type": item.customerType,
        Source: item.source,
        "Referred By": item.referredBy,
        "Investment Status": item.investmentStatus,
        "Activation Bonus Redeemed": item.activationBonusRedeemed,
      }));
      if (selectedDownloadType === "XLSX") {
        downloadExcel(generatedExcelSheet);
      }
    } else if (isCustomerSource) {
      const generatedExcelSheet = report.map((item) => ({
        "Registration Date": item.registrationDate,
        "Customer ID": item.customerId,
        "Customer Name": `${item.customerName ?? "."} ${item.companyName ?? "."}`,
        "Customer Type": item.customerType,
        Channel: item.registrationChannel,
        Source: item.source,
        "Referred By": item.referredBy ?? "N/A",
        Others: item.others,
        "Investment Status": item.investmentStatus,
      }));
      if (selectedDownloadType === "XLSX") {
        downloadExcel(generatedExcelSheet);
      }
    } else {
      if (selectedDownloadType === "XLSX") {
        downloadExcel(report);
      }
    }

    if (selectedDownloadType === "CSV" && csvRef.current) {
      setTimeout(() => {
        csvRef.current.link.click();
      }, 100);
    }
  };

  const reportTypeOptions = Object.entries(reportTypeEnum).map(([key, value]) => ({
    label: key.split("_").join(" "),
    value,
  }));

  const resetFilterFields = () => {
    setFields(initialFieldsDTO);
    setCurrentPage(1);
  };

  return (
    <React.Fragment>
      <Head title="Reports"></Head>
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Reports</BlockTitle>
                {!!generatedCsvReport.length && selectedDownloadType === "CSV" && (
                  <CSVDownload
                    ref={csvRef}
                    data={generatedCsvReport}
                    filename={`${reportType.toLowerCase()}.csv`}
                    target="_blank"
                  />
                )}
                <DropSelectButton
                  options={["PDF", "XLSX", "CSV"]}
                  onClick={() => {
                    if (selectedDownloadType === "PDF") {
                      savePdf();
                    } else if (selectedDownloadType === "XLSX" || selectedDownloadType === "CSV") {
                      handleGenerateDocs(handleDownload);
                    }
                  }}
                  onChange={handleSelectDownloadType}
                >
                  {isGeneratingReport ? "Generating" : `DOWNLOAD ${selectedDownloadType}`}
                </DropSelectButton>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Row className="d-flex justify-content-end px-3 mb-5">
            <Col md="3" className="bg-white p-2 rounded text-center mx-2" style={{ cursor: "pointer" }}>
              <label className="form-label">Start Date</label>
              <input
                type="date"
                name="startDate"
                value={startDate}
                max={new Date().toISOString().split("T")[0]}
                onChange={onInputChange}
                className="form-control"
                // ref={register({
                //   required: "This field is required",
                // })}
              />
            </Col>
            <Col md="3" className="bg-white p-2 rounded text-center ml-2" style={{ cursor: "pointer" }}>
              <label className="form-label">End Date</label>
              <input
                type="date"
                name="endDate"
                value={endDate}
                disabled={!startDate}
                min={startDate}
                max={new Date().toISOString().split("T")[0]}
                onChange={onInputChange}
                className="form-control"
                // ref={register({
                //   required: "This field is required",
                //   validate: (value) => !startDate || value >= startDate || "End date cannot be before start date",
                // })}
              />
            </Col>
          </Row>
          <Row md="3" className="d-flex justify-content-end px-3">
            <FormGroup>
              <label className="form-label">Report Type</label>
              <RSelect
                options={reportTypeOptions}
                value={reportTypeOptions.filter(({ value }) => value === reportType)[0]}
                placeholder="Select Report Type"
                onChange={(e) => handleReportTypeChange(e.value)}
                // ref={register({ required: true })}
              />
            </FormGroup>
          </Row>
          <Row md="12" className="d-flex px-3 mt-5">
            {reportType === reportTypeEnum.TRANSACTION && (
              <>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Transaction Type</label>
                    <RSelect
                      options={transactionTypeOptions}
                      name="transactionType"
                      onChange={(e) => handleSelectChange(e, "transactionType")}
                      value={transactionTypeOptions.filter(({ value }) => fields?.transactionType === value)[0]}
                      // ref={register({
                      //   required: "This field is required",
                      // })}
                    />
                    {errors.transactionType && <span className="invalid">{errors.transactionType.message}</span>}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Customer Type</label>
                    <RSelect
                      options={customerTypeOptions}
                      name="customerType"
                      onChange={(e) => handleSelectChange(e, "customerType")}
                      value={customerTypeOptions.filter(({ value }) => fields?.customerType === value)[0]}
                      // ref={register({
                      //   required: "This field is required",
                      // })}
                    />
                    {errors.customerType && <span className="invalid">{errors.customerType.message}</span>}
                  </FormGroup>
                </Col>
                {fields.customerType === "customer_id" && (
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Customer ID</label>
                      <input
                        type="text"
                        name="customerId"
                        placeholder="Enter Customer ID"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.customerId && <span className="invalid">{errors.customerId.message}</span>}
                    </FormGroup>
                  </Col>
                )}
              </>
            )}
            {reportType === reportTypeEnum.ACTIVE_CUSTOMERS && (
              <>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Product Type</label>
                    <RSelect
                      options={productTypeOptions}
                      name="productType"
                      onChange={(e) => handleSelectChange(e, "activeProductType")}
                      value={productTypeOptions.filter(({ value }) => fields?.activeProductType === value)[0]}
                      // ref={register({
                      //   required: "This field is required",
                      // })}
                    />
                    {errors.productType && <span className="invalid">{errors.productType.message}</span>}
                  </FormGroup>
                </Col>
              </>
            )}
            {reportType === reportTypeEnum.CUSTOMER_WALLET_TRANSACTION && (
              <>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Customer Type</label>
                    <RSelect
                      options={customerTypeOptions}
                      name="customerType"
                      onChange={(e) => handleSelectChange(e, "customerType")}
                      value={customerTypeOptions.filter(({ value }) => fields?.customerType === value)[0]}
                      // ref={register({
                      //   required: "This field is required",
                      // })}
                    />
                    {errors.customerType && <span className="invalid">{errors.customerType.message}</span>}
                  </FormGroup>
                </Col>
                {fields.customerType === "customer_id" && (
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Customer ID</label>
                      <input
                        type="text"
                        name="customerId"
                        placeholder="Enter Customer ID"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.customerId && <span className="invalid">{errors.customerId.message}</span>}
                    </FormGroup>
                  </Col>
                )}
              </>
            )}
            {reportType === reportTypeEnum.ADHOC_INVESTMENT && (
              <>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Account Type</label>
                    <RSelect
                      options={accountTypeOptions}
                      name="customerType"
                      onChange={(e) => handleSelectChange(e, "accountType")}
                      value={accountTypeOptions.filter(({ value }) => fields?.accountType === value)[0]}
                      // ref={register({
                      //   required: "This field is required",
                      // })}
                    />
                    {errors.customerType && <span className="invalid">{errors.customerType.message}</span>}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Product Type</label>
                    <RSelect
                      options={investmentTypeOptions}
                      name="productType"
                      onChange={(e) => handleSelectChange(e, "productType")}
                      value={investmentTypeOptions.filter(({ value }) => fields?.investmentType === value)[0]}
                      // ref={register({
                      //   required: "This field is required",
                      // })}
                    />
                    {errors.productType && <span className="invalid">{errors.productType.message}</span>}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Filter By</label>
                    <RSelect
                      options={customerTypeOptions}
                      name="customerType"
                      onChange={(e) => handleSelectChange(e, "customerType")}
                      value={customerTypeOptions.filter(({ value }) => fields?.customerType === value)[0]}
                      // ref={register({
                      //   required: "This field is required",
                      // })}
                    />
                    {errors.customerType && <span className="invalid">{errors.customerType.message}</span>}
                  </FormGroup>
                </Col>
                {fields.customerType === "customer_id" && (
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Customer ID</label>
                      <input
                        type="text"
                        name="customerId"
                        placeholder="Enter Customer ID"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.customerId && <span className="invalid">{errors.customerId.message}</span>}
                    </FormGroup>
                  </Col>
                )}
              </>
            )}
            {reportType === reportTypeEnum.INVESTMENT && (
              <>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Investment Type</label>
                    <RSelect
                      options={investmentTypeOptions}
                      name="investmentType"
                      onChange={(e) => handleSelectChange(e, "investmentType")}
                      value={investmentTypeOptions.filter(({ value }) => fields?.investmentType === value)[0]}
                      // ref={register({
                      //   required: "This field is required",
                      // })}
                    />
                    {errors.investmentType && <span className="invalid">{errors.investmentType.message}</span>}
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Customer Type</label>
                    <RSelect
                      options={accountTypeOptions}
                      name="customerType"
                      onChange={(e) => handleSelectChange(e, "accountType")}
                      value={accountTypeOptions.filter(({ value }) => fields?.accountType === value)[0]}
                      // ref={register({
                      //   required: "This field is required",
                      // })}
                    />
                    {errors.customerType && <span className="invalid">{errors.customerType.message}</span>}
                  </FormGroup>
                </Col>
              </>
            )}
            {reportType === reportTypeEnum.REFERRALS && (
              <>
                <Col md="4">
                  <FormGroup>
                    <label className="form-label">Filter By</label>
                    <RSelect
                      options={filterByOptions}
                      name="filterBy"
                      onChange={(e) => handleSelectChange(e, "filterBy")}
                      value={filterByOptions.filter(({ value }) => fields?.filterBy === value)[0]}
                      // ref={register({
                      //   required: "This field is required",
                      // })}
                    />
                    {errors.filterBy && <span className="invalid">{errors.filterBy.message}</span>}
                  </FormGroup>
                </Col>
                {filterBy === "source" && (
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Source</label>
                      <RSelect
                        options={sourceOptions}
                        name="source"
                        onChange={(e) => handleSelectChange(e, "source")}
                        value={sourceOptions.filter(({ value }) => fields?.source === value)[0]}
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.customerType && <span className="invalid">{errors.customerType.message}</span>}
                    </FormGroup>
                  </Col>
                )}
                {filterBy === "referral_code" && (
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Referral Code</label>
                      <input
                        type="text"
                        name="referralCode"
                        placeholder="Enter Referral Code"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.customerType && <span className="invalid">{errors.customerType.message}</span>}
                    </FormGroup>
                  </Col>
                )}
                {fields.customerType === "customer_id" && filterBy === "referral_code" && (
                  <Col md="4">
                    <FormGroup>
                      <label className="form-label">Customer ID</label>
                      <input
                        type="text"
                        name="customerId"
                        placeholder="Enter Customer ID"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {errors.customerId && <span className="invalid">{errors.customerId.message}</span>}
                    </FormGroup>
                  </Col>
                )}
              </>
            )}
          </Row>
          <Card className="card-bordered card-preview mt-5" style={{ overflowX: "auto" }}>
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <ReportTable data={currentItems} reportType={reportType} reportTypeEnum={reportTypeEnum} />
            )}
          </Card>
          <div className="card-inner">
            {generatedReport && generatedReport.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={total}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Request found</span>
              </div>
            )}
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};
